module.exports = __webpack_public_path__ + "assets/img/cat-bowl.e491e219.jpg";